<app-survey-frame-list>
  <app-survey-frame-list-template template [id]="address.id" [index]="index" #frame>
    <div class="templateHeader" header>
      <div class="header-part">
        <ng-container *ngIf="!inPortrait; else keysPortrait">
          <div style="padding: 0;margin-right: 0.5rem" class="vertical-flex">
            <mat-icon *ngIf="getErrors(building?.id, address?.id)" style="color: red;">warning
            </mat-icon>
          </div>
          <div class="vertical-flex">
            <span class="bold">
              <span i18n="@@survey.inside.addressinfo.title.building">Building</span>
              <span> {{ buildingIndex }}</span>
            </span>
            <span>{{ buildingKey ?? "-" }}</span>
          </div>
          <div class="vertical-flex">
            <span class="bold">|</span>
            <span>|</span>
          </div>
          <div class="vertical-flex">
            <span class="bold">
              <span i18n="@@general.address">Address</span>
              {{ addressIndex }}
            </span>
            <span>{{ address?.lomKey ?? "-" }}</span>
          </div>
        </ng-container>
        <ng-template #keysPortrait>
          <div style="padding: 0;margin-right: 0.5rem" class="vertical-flex portrait">
            <mat-icon *ngIf="getErrors(building?.id, address?.id)" style="color: red;">warning
            </mat-icon>
          </div>
          <div class="vertical-flex portrait">
            <span><span class="bold">B{{ buildingIndex }}</span> -
              <span class="small">{{ buildingKey ?? "" }}</span></span>
            <span><span class="bold">A{{ addressIndex }}</span> -
              <span class="small">{{ address?.lomKey ?? "" }}</span></span>
          </div>
        </ng-template>
      </div>
      <div class="header-part">
        <span class="address"> {{ address.getFullAddress() }}</span>
      </div>
      <div class="header-part grow"></div>
      <div class="header-part">
        <div class="circle" *ngIf="address.isMainAddress">
          <mat-icon class="material-icons-outlined"> home </mat-icon>
        </div>
      </div>
      <div class="header-part no-wrap">
        <span class="photo-count"><span [class.red-count]="!viewmodel?.facadePhotos?.length">{{
            viewmodel?.facadePhotos?.length ?? 0
            }}</span>
          | <span>{{ viewmodel?.detailPhotos?.length ?? 0 }}</span></span>
      </div>
    </div>
    <div detail>
      <div class="holder">
        <div
          style="display: flex; align-items: center; gap: 1rem;"
          class="sub-title"
          [class.required]="address.isMainAddress"
          >
          <mat-icon *ngIf="getErrors(building.id, address.id,insideSurveyPhotoEnum.FACADE_PHOTO_SUBTITLE)"
            style="color: red;">warning
          </mat-icon>
          <span i18n="@@general.photo.facade">Photo facade</span>
        </div>
        <div class="row">
          <div class="col-md-12">
            <app-photo-and-remark [photos]="viewmodel.facadePhotos" [limit]="1" [isAuthCanWrite]="isAuthCanWrite"
              [isInsidePhoto]="false" [camera]="camera" [cameraLayer]="cameraLayer" [surveyId]="survey.id"
              [addressId]="address.id" [surveyType]="surveyType.Outside" [surveyPhotoType]="0"
              componentDescriptionTitle="Facade Photo">
            </app-photo-and-remark>
          </div>
        </div>
        <div class="sub-title" i18n="@@general.facade.details">
          Facade details
        </div>
        <div class="row">
          <div class="col-md-12">
            <app-photo-and-remark [photos]="viewmodel.detailPhotos" [limit]="75" [isAuthCanWrite]="isAuthCanWrite"
              [isInsidePhoto]="false" [camera]="camera" [cameraLayer]="cameraLayer" [surveyId]="survey.id"
              [addressId]="address.id" [surveyType]="surveyType.Outside" [surveyPhotoType]="1"
              componentDescriptionTitle="Facade Details">
            </app-photo-and-remark>
          </div>
        </div>
      </div>
    </div>
  </app-survey-frame-list-template>
</app-survey-frame-list>
